<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("museum module settings") }}
      </h1>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("drive module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_drive_product"
            name="chk_integrate_drive"
            v-model="meta.integrate_drive"
          />
          <label for="chk_integrate_drive_product">{{ $t("integrate") }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('drive')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/drive/catalog"
            name_field="name"
            value_field="drive_id"
            @selected="drive_changed"
            ref="drive_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="container">
      <hall-datatable ref="hall_datatable" />
    </div>

    <div class="columns mt-5">
      <div class="column"><area-datatable ref="area_datatable" /></div>
      <div class="column">
        <temporality-datatable ref="temporality_datatable" />
      </div>
    </div>
    <div class="columns">
      <div class="column"><style-datatable ref="style_datatable" /></div>
      <div class="column"><support-datatable ref="support_datatable" /></div>
    </div>

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  success_message,
  error_message,
} from "@/utils";
import { isEmpty } from "lodash";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import "bulma-extensions/bulma-checkradio/dist/css/bulma-checkradio.min.css";
import { v4 } from "uuid";
import HallDatatable from "./hall_datatable/Index.vue";
import AreaDatatable from "./area_datatable/Index.vue";
import TemporalityDatatable from "./temporality_datatable/Index.vue";
import StyleDatatable from "./style_datatable/Index.vue";
import SupportDatatable from "./support_datatable/Index.vue";

export default {
  name: "MuseumSettings",
  components: {
    GenericDropdown,
    HallDatatable,
    AreaDatatable,
    TemporalityDatatable,
    StyleDatatable,
    SupportDatatable,
  },
  data() {
    return {
      meta: {},
    };
  },
  methods: {
    save() {
      let v = this;
      let data = { ...v.meta };
      v.$root.loader(true);
      save_configuration(v, data)
        .then(() => {
          success_message(v.$t("configuration saved"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    drive_changed(drive) {
      let v = this;
      v.meta.drive_id = drive.drive_id;
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf && !isEmpty(conf)) {
          v.meta = conf;
        }
        if (conf && conf.drive_id)
          v.$refs.drive_dropdown.set_value(conf.drive_id);
      })
      .catch((error) => {
        error_message(error);
      })
      .finally(() => {
        v.$root.loader(false);
      });
  },
};
</script>

<style></style>
